import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import _ from "lodash";
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../utils/csvSanitizer';

import DataMiningFilterPanel from './DataMiningFilterPanel';
import InvoiceLinesFilterPanel from './invoiceLines/InvoiceLinesFilterPanel';
import InvoiceLinesPage from './invoiceLines/InvoiceLinesPage';
import IntrastatLinesFilterPanel from './intrastatLines/IntrastatLinesFilterPanel';
import IntrastatLinesPage from './intrastatLines/IntrastatLinesPage';
import DeleteLogFilterPanel from './deleteLog/DeleteLogFilterPanel';
import GLStatusVRSideFilterPanel from './glStatus/GLStatusVRSideFilterPanel';
import GLStatusVRSidePage from './glStatus/GLStatusVRSidePage';
import GLStatusGLSideFilterPanel from './glStatus/GLStatusGLSideFilterPanel';
import GLStatusGLSidePage from './glStatus/GLStatusGLSidePage';
import DeleteLogPage from './deleteLog/DeleteLogPage';
import DataMiningDetails from './DataMiningDetails';
import SiiTransactionsPage from './sii/SiiTransactionsPage';
import SiiTransactionsFilterPanel from './sii/SiiTransactionsFilterPanel';
import SIILogPage from './sii/SiiLogPage';
import SiiLogFilterPanel from './sii/SiiLogFilterPanel';
import ObligationsPage from '../MTD/ObligationsPage';
import PaymentsPage from '../MTD/PaymentsPage';
import LiabilitiesPage from '../MTD/LiabilitiesPage';
import MTDFilterPanel from '../MTD/FilterPanel';
import InvoiceLines from './reportDefinition/InvoiceLines.json';
import ChangesLogLines from './reportDefinition/ChangesLogLines.json';
import ReportingCombinationsHistoryLines from './reportDefinition/ReportingCombinationsHistoryLines';
import ProcessingLogLines from './reportDefinition/ProcessingLogLines.json';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ComponentUtil from '../../utils/componentUtil';
import { TransactionReportTypeEnum } from '../../utils/enums';
import ReactComponentHelper from '../helper/ReactComponentHelper';
import { FIELDS as GLOBAL_FILTER_PANEL_FIELDS } from '../filter/GlobalFilterPanel';

import DATA_MINING_CONTROLLER from '../../controllers/dataMining';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';

import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../../utils/logger';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import StaticApplicationMessage from '../inAppMessages/StaticApplicationMessage';
import getClientConfig from '../../utils/getClientConfig';
import dateformat from 'dateformat';
const log = new Logger('DATA_MINING_PAGE', LOG_LEVELS.DEBUG);

const PAGE_INTERNAL_IDS = [
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COUNTRY_CODE,
];

const ChangesLogColumnMapping = {
    "nr": "Nr", "companyCode": "Company Code", "companyName": "Company", "invoiceNumber": "Invoice Number", "tagName": "Tag Name", "oldValue": "Old Value", "newValue": "New Value",
    "userChange": "User Change", "changedBy": "Changed By", "changeDate": "Change Date", "parentFileName": "Parentfilename"
};

const ReportingCombinationsHistoryLinesColumnMapping = {
    "nr": "Nr", "id": "ID", "startingDate": "Starting Date", "deletionDate": "Deletion Date",
    "reportingCombinationId": "Reporting Combination ID", "username": "User Name", "reporterId": "Reporter ID", "userCode": "User Code", "vatCode": "VAT Code",
    "countryAsString": "Country", "vatRate": "VAT Rate", "vatRateType": "VAT Rate Type", "combinationIdInvoice": "Combination ID Invoice", "combinationIdCredit": "Combination ID Credit",
    "intrastatIncoming": "Intrastat In", "intrastatOutgoing": "Intrastat Out", "icListing": "EC Listing", "deductibleVat": "Deductible VAT", "goodType": "Good Type", "mainVatCode": "Main VAT Code",
    "lineFlowType": "Line Flow Type", "iVatTransactionId": "VAT Reporting Transaction ID", "startDate": "Start Date", "endDate": "End Date", "itemType": "Item Type", "vatCodeFlow": "VAT Code Flow",
    "extraReports": "Extra Reports", "revisionVatCodeTaxBConvertedToVat": "Revision VAT Code", "fixedAsset": "Fixed Asset", "refundVatCode": "Refund VAT Code",
    "refundType": "Refund Type", "vatCodeForVatUnit": "VAT Code For VAT Unit", "proRata": "ProRata", "recalculateVat": "Recalculate VAT", "dateUsedForReporting": "Date Used For Reporting",
    "extraDescription": "Extra Description", "reverseChargeDocument": "Reverse Charge Document", "miniOneStopShop": "MOSS", "withholdingRate": "Withholding Rate",
    "extraTaxbBoxes": "Extra Taxb Boxes", "extraVatBoxes": "Extra VAT Boxes", "extraTaxbBoxesCredit": "Extra Taxb Boxes Credit", "extraVatBoxesCredit": "Extra VAT Boxes Credit"
};

const DataProcessingDetailsColumnMapping = { "nr": "Nr", "id": "ID", "dateTimeStamp": "Date TimeStamp", "message": "Message" };

const USER_ACTIVITY_REPORT_TYPES = ['Changes log', 'Delete log', 'VAT code history'];

const { userActivityLogCutoffDate } = getClientConfig();

function parseQueryParams(string) {
    log.debug('parseQueryParams: string: ', string);
    const originalQp = QueryString.parse(string, { arrayFormat: 'index' });
    const decodedQp = _.each(originalQp, (value, key) => { return decodeURIComponent(value); });
    log.debug('parseQueryParams: ', originalQp, decodedQp);
    return decodedQp;
}

function stringifyQueryParams(qp) {
    const encodedQp = _.each(qp, (value, key) => { return encodeURIComponent(value); });
    log.debug('sqp: ', qp, encodedQp);
    return QueryString.stringify(encodedQp, { arrayFormat: 'index' });
}
/* This file has TODO comments, we will remove/revisit those code once we refactored(create new page for each report type) this page for all report types*/

class Page extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pages: -1,
            loading: true,
            pageSize: 1000,
            count: 0,
            page: 1,
            sorted: [],
            filtered: [],
            isSearchClicked: true,
            currentReportType: '',
            reportTypeOnApply: '',
            lastFilterCriteria: {},
            isInitialLoad: false, //TODO -temp flag to determine if reportType changed from InvoiceLines,DeleteLog 
            isReportTypeChanged: false //flag to identify if apply is clicked again on same report type inorder to trigger fetchData in respective page 
        };
        this.fetchData = this.fetchData.bind(this);
        this.getPageSize = this.getPageSize.bind(this);
        this.filterSelectionHandler = this.filterSelectionHandler.bind(this);
        this.onFilterApply = this.onFilterApply.bind(this);
        this.onReconcileClick = this.onReconcileClick.bind(this);
        this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
        this.onApplyClickHandler = this.onApplyClickHandler.bind(this);
    }

    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);

        this.setState({
            currentReportType: (selection && selection.reportType) || '',
            filtered: [],
            sorted: []
        });
    }

    onApplyClickHandler(selection = {}) {
        log.debug('onApplyClickHandler() reportType', selection.reportType);
        let isReportTypeChanged = this.state.isReportTypeChanged;
        if (_.isEqual(selection.reportType, this.state.reportTypeOnApply))
            isReportTypeChanged = false;
        else
            isReportTypeChanged = true;

        this.setState({
            lastFilterCriteria: selection,
            reportTypeOnApply: this.state.currentReportType,
            isReportTypeChanged: isReportTypeChanged
        });
        ComponentUtil.updateUrlParams(this.props.location, this.props.history, selection);
    }

    filterSelectionHandler(keyValuePairs) {
        log.debug('filterSelectionHandler() Key value pairs: ', keyValuePairs);
        const key = Object.keys(keyValuePairs)[0];
        const values = Object.values(keyValuePairs)[0];
        let parsedQueryParams = parseQueryParams(this.props.location.search);
        let newQueryParams = parsedQueryParams;
        log.debug('filterSelectionHandler() parsedQueryParams: ', parsedQueryParams);
        this.setState({ isSearchClicked: false });
        if (values === '' || values === 'false') {
            delete parsedQueryParams[key];
            newQueryParams = parsedQueryParams;
            this.props.history.push({
                search: stringifyQueryParams(parsedQueryParams)
            });
        } else {
            newQueryParams = Object.assign({}, parsedQueryParams, keyValuePairs);
            log.debug('filterSelectionHandler() newQueryParams:', newQueryParams);
            this.props.history.push({
                search: stringifyQueryParams(newQueryParams)
            });
        }
    }

    getParameters(filterCriteria, startAt, pageSize) {
        const isIamUser = this.props.iamData && this.props.iamData.isIamUser;
        let params = {};
        switch (filterCriteria.reportType) {
            case "Changes log":
                // Apply end-date cut-off logic conditionally
                let adjustedEndDate = filterCriteria.endDate;
                if (isIamUser && filterCriteria.endDate && moment(filterCriteria.endDate).isAfter(moment(userActivityLogCutoffDate))) {
                    adjustedEndDate = userActivityLogCutoffDate;
                }
                
                params = {
                    companyId: filterCriteria.companyId,
                    periodStartDate: filterCriteria.startDate,
                    periodEndDate: adjustedEndDate,
                    startAt: startAt === 0 ? 1 : (startAt + 1),
                    count: pageSize,
                    reportType: filterCriteria.reportType
                };
                break;
            case "File processing log":
                params = {
                    periodStartDate: filterCriteria.startDate,
                    periodEndDate: filterCriteria.endDate,
                    startAt: startAt === 0 ? 1 : (startAt + 1),
                    count: pageSize,
                    reportType: filterCriteria.reportType
                };
                break;
            case "VAT code history":
                params = {
                    companyId: filterCriteria.companyId === 'Generic' ? '-101' : filterCriteria.companyId,
                    periodStartDate: '1900-01-01',
                    periodEndDate: isIamUser ? userActivityLogCutoffDate : '3000-01-01',
                    startAt: startAt === 0 ? 1 : (startAt + 1),
                    count: pageSize,
                    reportType: filterCriteria.reportType
                };
                break;
            default:
                params = {
                    startAt: startAt === 0 ? 1 : (startAt + 1),
                    count: pageSize,
                    month: filterCriteria.month,
                    year: filterCriteria.year,
                    reportType: filterCriteria.reportType
                };
        }
        return params;
    }

    getPageSize() {
        return Object.is(this.state.pageSize, NaN) ? 1000 : this.state.pageSize;
    }

    onFilterApply(filterCriteria) {
        let initialLoad = false;
        if (!_.isEqual(filterCriteria.reportType, this.state.reportTypeOnApply))
            initialLoad = true;

        this.setState({
            lastFilterCriteria: filterCriteria,
            reportTypeOnApply: filterCriteria.reportType,
            isInitialLoad: initialLoad
        });
        log.debug("onFilterApply(): filterCriteria: ", filterCriteria);
        const pageSize = this.getPageSize();
        const startAt = this.state.page * pageSize;
        let params = this.getParameters(filterCriteria, startAt, pageSize);
        this.props.clearDataForAllReports();
        let urlParams = Object.assign({}, filterCriteria);
        if (!_.isEmpty(filterCriteria) && !_.isEmpty(filterCriteria.reportType)) {
            PAGE_INTERNAL_IDS.forEach(key => delete urlParams[key]);
            this.setState({ isSearchClicked: true, loading: true });
            this.props.onPageLoad(params, () => {
                this.setState({
                    loading: false
                });
            });
        }
        ComponentUtil.updateUrlParams(this.props.location, this.props.history, urlParams);
    }

    onReconcileClick() {
        this.props.onGLReconciliationDone(() => {
            this.onFilterApply(this.state.lastFilterCriteria);
        });
    }

    /**
     * Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
     *
     * @param {any} state
     * @param {any} instance
     * @memberof Page
     */
    fetchData(state, instance) {
        log.debug("fetchData ");
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        const pageSize = Object.is(state.pageSize, NaN) ? 1000 : state.pageSize;
        const page = Object.is(state.page, NaN) ? 0 : state.page;
        const startAt = page * pageSize;
        this.setState({
            pageSize: pageSize,
            page: page,
            sorted: state.sorted,
            filtered: state.filtered
        });
        let parsedQueryParams = parseQueryParams(this.props.location.search);
        let isFetchRequired = true;
        if (parsedQueryParams && _.includes([TransactionReportTypeEnum.INVOICELINES.value, TransactionReportTypeEnum.INTRASTATLINES.value, TransactionReportTypeEnum.DELETELOG.value], parsedQueryParams.reportType))
            isFetchRequired = false;
        let globalFilterCriteria = GLOBAL_FILTER_CONTROLLER.getAll();
        let filterCriteria = Object.assign({}, parsedQueryParams, globalFilterCriteria);
        let params = this.getParameters(filterCriteria, startAt, pageSize);

        //Only make request for non-sorting or non-filter update
        let requestData = _.isEqual(this.state.filtered, state.filtered) && _.isEqual(this.state.sorted, state.sorted) && !_.isEmpty(params.reportType) && !this.state.isInitialLoad && isFetchRequired;
        if (requestData) {
            log.debug("fetchData inside requestData if ");
            if (!_.isEmpty(filterCriteria)) {
                ComponentUtil.updateUrlParams(this.props.location, this.props.history, params);
                this.setState({ isSearchClicked: true, loading: true });
                this.props.clearDataForAllReports();
                this.props.onPageLoad(params, () => {
                    this.setState({
                        loading: false
                    });
                });
            } else {
                this.setState({
                    loading: false
                });
            }
        } else {
            this.setState({
                loading: false,
                isInitialLoad: false
            });
        }
    }

    componentDidMount() {
        log.debug('componentDidMount() - ');
        log.clearAllDictionaryErrors();
        let parsedQueryParams = parseQueryParams(this.props.location.search);
        log.debug('componentDidMount() - parsedQueryParams: ', parsedQueryParams);
        let globalFilterCriteria = GLOBAL_FILTER_CONTROLLER.getAll();
        log.debug('componentDidMount() - globalFilterCriteria: ', globalFilterCriteria);
        let filterCriteria = Object.assign({}, parsedQueryParams, globalFilterCriteria);
        if (!_.isEmpty(filterCriteria)) {
            PAGE_INTERNAL_IDS.forEach(key => delete filterCriteria[key]);
            ComponentUtil.updateUrlParams(this.props.location, this.props.history, filterCriteria);
        }
        //Incase of page reload
        if (parsedQueryParams && _.includes([TransactionReportTypeEnum.INVOICELINES.value, TransactionReportTypeEnum.INTRASTATLINES.value, TransactionReportTypeEnum.DELETELOG.value, TransactionReportTypeEnum.SIITRANSACTIONS.value], parsedQueryParams.reportType)) {
            this.setState({
                lastFilterCriteria:parsedQueryParams,
                currentReportType: parsedQueryParams.reportType,
                reportTypeOnApply: parsedQueryParams.reportType
            });
        }
    }

    componentDidUpdate(prevProps) {
        log.debug("componentDidUpdate():  nextProps: ", prevProps);
        let currentProps = this.props;
        if (prevProps.invoiceData !== currentProps.invoiceData && currentProps.invoiceData !== undefined) {
            log.debug("componentDidUpdate():: ", currentProps.invoiceData);
            let invoiceData = currentProps.invoiceData || [];
            let totalCount = (currentProps.invoiceData && currentProps.invoiceData.totalCount) || invoiceData.length;
            let pageCount = this.state.pageSize === 0 ? totalCount : Math.ceil(totalCount / this.state.pageSize);
            let tablePaginationNewState = {
                count: totalCount,
                pages: pageCount
            };
            log.debug("componentDidUpdate(): tablePaginationNewState: ", tablePaginationNewState);
            this.setState(tablePaginationNewState);
        }
    }

    componentWillUnmount() {
        log.debug('componentDidUnmount() - ');
        this.props.clearDataForAllReports();
    }

    render() {
        log.debug('render(): ');
        let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
        let parsedQueryParams = Object.assign({}, globalFilterSelection, parseQueryParams(this.props.location.search));
        log.debug('render(): queryParams', parsedQueryParams, parsedQueryParams.reportType);
        let invoiceData = (this.props.invoiceData && this.props.invoiceData.data) || [];
        let sortedInvoiceData = invoiceData;
        if (this.state.isSearchClicked === true) {
            switch (parsedQueryParams.reportType) {
                case 'Changes log':
                    //Update column names to match with VR Excel report
                    for (var key in ChangesLogColumnMapping) {
                        sortedInvoiceData = JSON.parse(JSON.stringify(sortedInvoiceData).split('"' + key + '":').join('"' + ChangesLogColumnMapping[key] + '":'));
                    }
                    break;
                case 'VAT code history':
                    // Update column names to match with VR Excel report
                    for (var key in ReportingCombinationsHistoryLinesColumnMapping) {
                        sortedInvoiceData = JSON.parse(JSON.stringify(sortedInvoiceData).split('"' + key + '":').join('"' + ReportingCombinationsHistoryLinesColumnMapping[key] + '":'));
                    }
                    break;
                case 'File processing log':
                    // Update column names to match with VR Excel report
                    for (var key in DataProcessingDetailsColumnMapping) {
                        sortedInvoiceData = JSON.parse(JSON.stringify(sortedInvoiceData).split('"' + key + '":').join('"' + DataProcessingDetailsColumnMapping[key] + '":'));
                    }
                    break;
            }
        }

        let filteredInvoiceData = sortedInvoiceData;
        if (this.state.filtered && this.state.filtered.length) {
            filteredInvoiceData = this.state.filtered.reduce((filteredSoFar, nextFilter) => {
                return filteredSoFar.filter(row => {
                    return (row[nextFilter.id] + "").includes(nextFilter.value);
                });
            }, filteredInvoiceData);
        }

        let sortedInvoiceDataUpdated = filteredInvoiceData;
        if (this.state.sorted && this.state.sorted.length) {
            sortedInvoiceDataUpdated = _.orderBy(
                filteredInvoiceData,
                this.state.sorted.map(sort => {
                    return row => {
                        if (row[sort.id] === null || row[sort.id] === null) {
                            return -Infinity;
                        }
                        return typeof row[sort.id] === "string" ?
                            row[sort.id].toLowerCase() :
                            row[sort.id];
                    };
                }),
                this.state.sorted.map(d => (d.desc ? "desc" : "asc"))
            );
        }

        let fileName = 'DataMining.csv';
        if (parsedQueryParams !== undefined && parsedQueryParams['reportType'] !== undefined)
            fileName = parsedQueryParams['reportType'].replace(' ', '') + '.csv';

        var columnData = [];
        // TODO change this for the enums
        switch (parsedQueryParams['reportType']) {
            case 'Changes log':
                columnData = ChangesLogLines;
                break;
            case 'VAT code history':
                columnData = ReportingCombinationsHistoryLines;
                break;
            case "File processing log":
                columnData = ProcessingLogLines;
                break;
            default:
                columnData = InvoiceLines;
        }
        let dateCols = columnData.filter((column) => column.IsDate).map(column => column.Accessor);
        let currencyCols = columnData.filter((column) => column.IsCurrency).map(column => column.Accessor);
        let dateAndCurrencyFormatedInvoiceData = sortedInvoiceDataUpdated.map(dataRow => {
            dateCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? `${dataRow[accessor]}`.substr(0, 10) : dataRow[accessor];
                const formattedDate = (dataRow[accessor] === "1899-12-30" ? "" : dataRow[accessor])
                dataRow[accessor] = formattedDate
            });
            currencyCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? ReactComponentHelper.formatToCurrency(dataRow[accessor]) : dataRow[accessor];
            });
            return dataRow;
        });
        let currentReportType = this.state.currentReportType;
        let reportTypeOnApply = this.state.reportTypeOnApply;

        return (
            <div className="content-area mb10">
                <s-container>
                    <ApplicationMessages  messageIds={[ ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH ]}
                                          messageType="applicationError"/>
                    <h1>
                        <LanguageStringResolver string='TitleDataMining' />
                        {
                            _.isEmpty(currentReportType) ? (
                                <span></span>
                            ) : (
                                    <span>
                                        <span className="ml10 mr10">-</span>
                                        <span>{currentReportType}</span>
                                    </span>
                                )
                        }
                    </h1>

                    {/* Info message for reports with cutoff date */}
                    {(USER_ACTIVITY_REPORT_TYPES.includes(currentReportType)) && (() => {
                        const isIamUser = this.props.iamData && this.props.iamData.isIamUser;
                        if (isIamUser) {
                            return (
                                <StaticApplicationMessage
                                    messageType="applicationInfo"
                                    string="TransactionsReportsPage_CutoffDateInfo"
                                    languages={this.props.languages}
                                    params={[dateformat(new Date(userActivityLogCutoffDate), "d mmmm yyyy")]}
                                    nodismiss={true} />
                            );
                        }
                        return null;
                    })()}

                    {
                        ((currentReportType) => {
                            switch (currentReportType) {
                                case TransactionReportTypeEnum.INVOICELINES.value:
                                    return (
                                        <InvoiceLinesFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler} />
                                    );
                                case TransactionReportTypeEnum.INTRASTATLINES.value:
                                    return (
                                        <IntrastatLinesFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler} />
                                    );
                                case TransactionReportTypeEnum.DELETELOG.value:
                                    return (
                                        <DeleteLogFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler} />
                                    );
                                case TransactionReportTypeEnum.GLSTATUSVRSIDE.value:
                                    return (
                                        <GLStatusVRSideFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler}
                                        />
                                    );
                                case TransactionReportTypeEnum.GLSTATUSGLSIDE.value:
                                    return (
                                        <GLStatusGLSideFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler}
                                        />
                                    );
                                case TransactionReportTypeEnum.SIITRANSACTIONS.value:
                                    return (
                                        <SiiTransactionsFilterPanel
                                          onReportTypeChange={this.onReportChangeHandler}
                                          onSearchClick={this.onApplyClickHandler}
                                        />
                                    );
                                case TransactionReportTypeEnum.SIILOG.value:
                                    return (
                                        <SiiLogFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler} />
                                    );
                                case TransactionReportTypeEnum.MTDLIABILITY.value:
                                case TransactionReportTypeEnum.MTDPAYMENTS.value:
                                case TransactionReportTypeEnum.MTDRETURNS.value:
                                    return (
                                        <MTDFilterPanel
                                            onReportTypeChange={this.onReportChangeHandler}
                                            onSearchClick={this.onApplyClickHandler}
                                            reportTypeSelected = {currentReportType}
                                        />
                                    );
                                default: //TODO
                                    return (<div>
                                        <DataMiningFilterPanel
                                            month={parsedQueryParams.month}
                                            year={parsedQueryParams.year}
                                            selectionHandler={this.filterSelectionHandler}
                                            onApply={this.onFilterApply}
                                            selectValue={parsedQueryParams}
                                            disableSearch={_.isEmpty(parsedQueryParams.reportType)}
                                            onChange={this.onReportChangeHandler}
                                            reportType={currentReportType}
                                        />
                                    </div>);
                            }
                        })(currentReportType)
                    }
                    {
                        ((reportTypeOnApply) => {
                            switch (reportTypeOnApply) {
                                case TransactionReportTypeEnum.INVOICELINES.value:
                                    return (
                                        <InvoiceLinesPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.INTRASTATLINES.value:
                                return (
                                    <IntrastatLinesPage
                                        filterCriteria={this.state.lastFilterCriteria}
                                        isReportTypeChanged={this.state.isReportTypeChanged} />
                                );
                                case TransactionReportTypeEnum.DELETELOG.value:
                                    return (
                                        <DeleteLogPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.GLSTATUSVRSIDE.value:
                                    return (
                                        <GLStatusVRSidePage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.GLSTATUSGLSIDE.value:
                                    return (
                                        <GLStatusGLSidePage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.SIITRANSACTIONS.value:
                                    return (
                                        <SiiTransactionsPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged}
                                        />
                                    );
                                case TransactionReportTypeEnum.SIILOG.value:
                                    return (
                                        <SIILogPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.MTDRETURNS.value:
                                    return (
                                        <ObligationsPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.MTDLIABILITY.value:
                                    return (
                                        <LiabilitiesPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                case TransactionReportTypeEnum.MTDPAYMENTS.value:
                                    return (
                                        <PaymentsPage
                                            filterCriteria={this.state.lastFilterCriteria}
                                            isReportTypeChanged={this.state.isReportTypeChanged} />
                                    );
                                default: //TODO
                                    return (<div>
                                        <DataMiningDetails
                                            pages={Object.is(this.state.pages, NaN) ? 0 : this.state.pages}
                                            data={sortedInvoiceDataUpdated}
                                            loading={this.state.loading}
                                            onFetchData={this.fetchData}
                                            pageSizeOptions={[1000, 2000, 5000, 10000]}
                                            defaultPageSize={this.state.pageSize}
                                            columnData={columnData}
                                            filterOption={this.state.filtered}
                                        />
                                        <CSVLink
                                            data={sanitizeCsvData(dateAndCurrencyFormatedInvoiceData)}
                                            filename={fileName}
                                            className={dateAndCurrencyFormatedInvoiceData && dateAndCurrencyFormatedInvoiceData.length > 0 ? "button secondary" : "invisible"}>
                                            <LanguageStringResolver string='viewTransmission_ExportToCSV' />
                                        </CSVLink>

                                    </div>);
                            }
                        })(reportTypeOnApply)
                    }
                </s-container>
            </div>
        );
    }
}


function mapStateToProps(state) {
    const stateProps = {
        languages: state.languages,
        invoiceData: (state.dataMining && state.dataMining.invoiceLines),
        siiTransactions: (state.dataMining && state.dataMining.siiTransactions),
        iamData: state.authentication && state.authentication.data && state.authentication.data.iamData
    };
    return stateProps;
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.onPageLoad = (params, callback) => {
        log.debug('onPageLoad ', params, params['reportType']);
        // TODO change to enums
        switch (params['reportType']) {
            case 'Changes log':
                dispatch(DATA_MINING_CONTROLLER.doGetChangesLog(params, callback));
                break;
            case 'VAT code history':
                dispatch(DATA_MINING_CONTROLLER.doGetVAtCodesHistory(params, callback));
                break;
            case "File processing log":
                dispatch(DATA_MINING_CONTROLLER.doGetProcessedDocumentData(params, callback));
                break;
            case 'SII transactions':
                dispatch(DATA_MINING_CONTROLLER.getSIITransactions(params));
                break;
        }
    };
    dispatchProps.clearDataForAllReports = () => {
        dispatch(DATA_MINING_CONTROLLER.doClearDataForAllReports());
    };
    dispatchProps.onGLReconciliationDone = (callback) => {
        log.debug('onGLReconciliationDone');
        dispatch(DATA_MINING_CONTROLLER.doGLReconciliation(callback));
    }
    return dispatchProps;
}

export default connect(mapStateToProps, mapDispatchersToProps)(Page);
